import { Injectable } from '@angular/core';
import { HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
export const SKIP_REQUEST_MUTATORS = new HttpContextToken<boolean>(() => false);

@Injectable()
export class SkipRequestMutatorsInterceptor implements HttpInterceptor {
  /**
   * List of subdomain for which to skip the request mutators
   */
  private readonly SKIP_SUBDOMAINS = ['auth', 'login']; // Cognito endpoints: <domain>.auth.<region>.amazoncognito.com

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const hostname = this.getHostname(req.url)?.toLowerCase();

    if (hostname && this.shouldSkip(hostname)) {
      req = req.clone({
        context: req.context.set(SKIP_REQUEST_MUTATORS, true),
      });
    }

    return next.handle(req);
  }

  private shouldSkip(hostname: string): boolean {
    const labels = hostname.split('.');
    return labels.some((label) => this.SKIP_SUBDOMAINS.includes(label));
  }

  private getHostname(url: string): string | null {
    if (!/^https?:\/\//i.test(url)) return null; // relative URL
    try {
      return new URL(url).hostname; // hostname only, no port
    } catch {
      return null;
    }
  }
}
